var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeaderCompany = function SvgHeaderCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMin slice",
    viewBox: "0 0 509.619 294.627"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "header-company_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h509.619v294.627H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#header-company_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#83cbdb",
    d: "M119.5 294.627c3.008-31.889 21.039-55.785 32.256-67.769L231.434 148a10.5 10.5 0 0 1 7.178-2.991h.268a10.52 10.52 0 0 1 7.179 2.991l79.378 78.583c11.472 12.258 29.521 36.175 32.532 68.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#daebdb",
    d: "M394.392 221.169c-47.161-26.269-90.2-57.569-122.981-101.241C254.787 97.7 243.744 72.9 242.665 44.823q-.082-2.163-.091-4.349v-.952A121.4 121.4 0 0 1 249.187 0h260.432v141.223c-16.481 18.1-35.49 33.767-55.515 48.41a449 449 0 0 1-48.412 30.5c-2.316 1.282-4.5 2.284-6.837 2.285a9 9 0 0 1-4.463-1.249"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ede44f",
    d: "m116.4 156.116-34.83-34.889a4.47 4.47 0 0 0-6.323-.016l-.016.016L40.4 156.116A44.69 44.69 0 0 1 0 168.39V0h196.3l-27.947 27.99a4.49 4.49 0 0 0 0 6.349l34.834 34.889-.021-.02a45.127 45.127 0 0 1 0 63.675l-23.194 23.233a44.946 44.946 0 0 1-63.563.006l-.006-.006Z"
  }))));
};
export default SvgHeaderCompany;